import { ServiceClient } from 'src/utils'
import { Cfop } from './cfop.types'

const serviceClient = ServiceClient.singleton()

export class CfopService {
    static #INSTANCE = new CfopService()
    static readonly singleton = () => CfopService.#INSTANCE

    async fetchCfops() {
        return serviceClient.authGet<Cfop[]>(`/api/v1/cfops`)
    }
}

export default CfopService.singleton()
